import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';

const classes = {
	itemBtn: 'm-talk__btn'
};

@createModule('Talk')
/**
 * Talk module implementation.
 *
 */
export class Talk extends TerrificSpec {
	$ctx: JQuery;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		this.RegisteredUpdate();

		resolve();
	}

	RegisteredUpdate() {
		if(Track.isKnownMarketoLead()) {
			this.$ctx.removeClass('m-talk--locked');
		}

		if(Track.isKnownCdcLead()) {
			this.$ctx.removeClass('m-talk--locked');
		}
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
}
